module.exports = __webpack_public_path__ + "img/el-m-out25.b2eb830e.png";